// extracted by mini-css-extract-plugin
module.exports = {"SectionCard":"SectionCard_SectionCard__aIzV0"};